import { inject, InjectionToken } from '@angular/core';
import { APP_ROUTE_CONSTANTS, NavigationConfig } from '@shared/core';

export const DEFAULT_NAVIGATION_CONFIG = new InjectionToken<NavigationConfig>('DEFAULT_NAVIGATION_CONFIG', {
    providedIn: 'root',
    factory: () => {
        const routeConstants = inject(APP_ROUTE_CONSTANTS);
        return {
            route: routeConstants['settings'],
            icon: 'las la-cog',
        };
    },
});
